<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('backupsettings' , 1) }}</div>
      <router-link
        class="btn-blue"
        to="backup-settings"
      >{{ $tc('backupsettings' , 1) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <!-- SELECT CINEMA -->
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="dropdown-curve-container">
            <label
              :class="selectedCinema.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
            <div class>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema);"
                  name="selectcinema"
                  id="selectcinema"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedCinema.length == 0"
              class="error_message"
            >{{ messagecinema }}</p>
          </div>
        </div>

        <!-- ENTER BACKUP LOCATION -->
        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label for="fileselector" class="file-selector w-100">
              <span>{{ item_image_url }}</span>
              <input
                type="file"
                v-on:change="uploadImage($event)"
                name="fileselector"
                id="fileselector"
                class="d-none"
              />
            </label>
            <Tooltip :title="$t('backupSettingBackupLocationBrowse_tooltip')" />
          </div>
          <p
            v-if="submitted && item_image_url == 'Browse Backup Location'"
            class="error_message"
          >Please Select Backup Location.</p>
        </div>-->

        <h5 class="border-bottom mx-3 pb-3 w-100">{{ $tc('backup', 2) }} {{ $tc('schedule', 2) }}</h5>

        <!-- DAILY BAKUP -->
        <div class="col-lg-12 col-xl-12 align-self-center py-4 border-bottom">
          <div class="row">
            <div class="col-lg-2 align-self-center">
              <div class="h6 mb-0">{{ $t('daily') }}</div>
            </div>
            <div class="col-lg-4 align-self-center"></div>
            <div class="col-lg-4 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="!schedule.daily"
                    v-model="cronTimer.daily.time"
                    type="text"
                    placeholder="19:00"
                    name="daily"
                    id="daily"
                  />
                  <label>{{ $t('time') }}</label>
                </div>
                <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
              </div>
            </div>
            <div class="col-lg-2 align-self-center">
              <div class="d-flex justify-content-center align-items-center">
                <label class="ios-switch">
                  <input
                    id="name_1"
                    type="checkbox"
                    class="ios-checkbox"
                    v-on:change="onChangeStatus($event,'daily')"
                    v-model="schedule.daily"
                  />
                  <span class="switch-slider"></span>
                </label>
                <Tooltip :title="$t('backupSettingDaily_tooltip')" />
              </div>
            </div>
          </div>
        </div>

        <!-- WEEKLY -->
        <div class="col-lg-12 col-xl-12 align-self-center py-4 border-bottom">
          <div class="row">
            <div class="col-lg-2 align-self-center">
              <div class="h6 mb-0">{{ $t('weekly') }}</div>
            </div>
            <div class="col-lg-4 align-self-center">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="selectedDay.length > 0 ? 'shift-up' : '' ">Select Day</label>
                  <b-dropdown
                    :disabled="!schedule.weekly"
                    :text="selectedDay"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      href="#"
                      v-for="(week, weekIndex) in cronTimer.weekly.weekArray"
                      :key="weekIndex"
                      v-on:click="onSelectDay($event, week,weekIndex);"
                      name="selectday"
                      id="selectday"
                    >{{ week }}</b-dropdown-item>
                  </b-dropdown>
                </div>
                <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
              </div>
            </div>
            <div class="col-lg-4 align-self-center">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="!schedule.weekly"
                    v-model="cronTimer.weekly.time"
                    type="text"
                    placeholder="13:00"
                    name="weeklyin"
                    id="weeklyin"
                  />
                  <label>{{ $t('time') }}</label>
                </div>
                <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
              </div>
            </div>
            <div class="col-lg-2 align-self-center">
              <div class="d-flex justify-content-center align-items-center">
                <label class="ios-switch">
                  <input
                    id="name_2"
                    type="checkbox"
                    class="ios-checkbox"
                    v-on:change="onChangeStatus($event,'weekly')"
                    v-model="schedule.weekly"
                  />
                  <span class="switch-slider"></span>
                </label>

                <Tooltip :title="$t('backupSettingWeekly_tooltip')" />
              </div>
            </div>
          </div>
        </div>

        <!-- MONTHLY -->
        <div class="col-lg-12 col-xl-12 align-self-center py-4 border-bottom">
          <div class="row">
            <div class="col-lg-2 align-self-center">
              <div class="h6 mb-0">{{ $t('monthly') }}</div>
            </div>
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <div class="input-container">
                  <input
                    :disabled="!schedule.monthly"
                    v-model="cronTimer.monthly.date"
                    type="text"
                    placeholder="31/06/2019"
                    name="monthly_1"
                    id="monthly_1"
                  />
                </div>
                <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
              </div>
            </div>
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="!schedule.monthly"
                    v-model="cronTimer.monthly.time"
                    type="text"
                    placeholder="13:30"
                    name="monthly_2"
                    id="monthly_2"
                  />
                  <label>{{ $t('time') }}</label>
                </div>
                <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
              </div>
            </div>
            <div class="col-lg-2 align-self-center">
              <div class="d-flex justify-content-center align-items-center">
                <label class="ios-switch">
                  <input
                    id="name_4"
                    type="checkbox"
                    class="ios-checkbox"
                    v-on:change="onChangeStatus($event,'monthly')"
                    v-model="schedule.monthly"
                  />
                  <span class="switch-slider"></span>
                </label>

                <Tooltip :title="$t('backupSettingMonthly_tooltip')" />
              </div>
            </div>
          </div>
        </div>

        <!-- FORTNIGHT -->
        <div class="col-lg-12 col-xl-12 align-self-center border-bottom py-4">
          <div class="row">
            <div class="col-lg-2">
              <div class="h6">{{ $t('fortnight') }}</div>
            </div>
            <!-- FORTNIGHT SETTINGS -->
            <div class="col-lg-8">
              <div class="row">
                <!-- FORTNIGHT START DATE -->
                <div class="col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="cronTimer.fortnight.startDate"
                          v-on:click="clearSelectedDate()"
                        >✖</button>
                        <Datepicker :monday-first="true"
                          :disabled="!schedule.fortnight"
                          ref="programaticOpen"
                          v-model="cronTimer.fortnight.startDate"
                          @selected="onChangeDate($event)"
                          name="fortnight_1"
                          id="fortnight_1"
                        ></Datepicker>
                        <label
                          :class="typeof cronTimer.fortnight.startDate === 'object' ? 'active': ''"
                        >Start Date</label>
                      </div>
                    </div>
                    <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                  </div>
                </div>

                <!-- FORTNIGHT END DATE -->
                <div class="col-lg-6 mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="cronTimer.fortnight.endDate"
                          v-on:click="clearSelectedDate()"
                        >✖</button>
                        <Datepicker :monday-first="true"
                          :disabled="!schedule.fortnight"
                          ref="programaticOpen"
                          v-model="cronTimer.fortnight.endDate"
                          @selected="onChangeDate($event)"
                          name="fortnight_2"
                          id="fortnight_2"
                        ></Datepicker>
                        <label
                          :class="typeof cronTimer.fortnight.endDate === 'object' ? 'active': ''"
                        >End Date</label>
                      </div>
                    </div>
                    <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                  </div>
                </div>

                <!-- FORTNIGHT START TIME -->
                <div class="col-lg-6">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :disabled="!schedule.fortnight"
                        v-model="cronTimer.fortnight.startTime"
                        type="text"
                        placeholder="16:30"
                        name="fortnight_3"
                        id="fortnight_3"
                      />
                      <label>{{ $t('time') }}</label>
                    </div>
                    <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                  </div>
                </div>

                <!-- FORTNIGHT END TIME -->
                <div class="col-lg-6">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :disabled="!schedule.fortnight"
                        v-model="cronTimer.fortnight.endTime"
                        type="text"
                        placeholder="16:30"
                        name="fortnight_4"
                        id="fortnight_4"
                      />
                      <label>{{ $t('time') }}</label>
                    </div>
                    <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 border-left">
              <div class="d-flex justify-content-center align-items-center h-100">
                <label class="ios-switch">
                  <input
                    id="name_3"
                    type="checkbox"
                    class="ios-checkbox"
                    v-on:change="onChangeStatus($event,'fortnight')"
                    v-model="schedule.fortnight"
                  />
                  <span class="switch-slider"></span>
                </label>

                <Tooltip :title="$t('backupSettingFortnight_tooltip')" />
              </div>
            </div>
          </div>
        </div>

        <!-- AUTOMATIC -->
        <div class="col-lg-12 col-xl-12 align-self-center border-bottom py-4">
          <div class="row">
            <div class="col-lg-6 align-self-center">
              <div class="d-flex align-items-center">
                <div class="h6 mb-0 mr-4">Automatic</div>
                <label class="ios-switch">
                  <input
                    id="name_5"
                    type="checkbox"
                    class="ios-checkbox"
                    v-on:change="onChangeStatus($event,'auto')"
                    v-model="schedule.auto"
                  />
                  <span class="switch-slider"></span>
                </label>

                <Tooltip :title="$t('backupSettingAuto_tooltip')" />
              </div>
            </div>

            <div class="col-lg-6 align-self-center">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">{{ $t('active') }}</label>
                <label class="ios-switch">
                  <input type="checkbox" class="ios-checkbox" checked />
                  <span class="switch-slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="backup-settings"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
// Main JS (in UMD format)
import CheckConnectionService from "@/services/CheckConnectionService.js";
// import VueTimepicker from "vue2-timepicker";

// CSS
// import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  // components: {
  //   VueTimepicker
  // },
  data() {
    return {
      btenable: false,
      isRoleID: true,
      messagecinema: "Please Select Cinema.",
      messageday: "Please Select Day.",
      errmsg: "",
      submitted: false,
      item_image_url: "Browse Backup Location",
      Cinemas: [],
      selectedCinema: "",
      selectedDay: "",
      cine_id: null,
      selectedSchedule: "daily",
      schedule: {
        daily: true,
        weekly: false,
        fortnight: false,
        monthly: false,
        auto: false
      },
      cronTimer: {
        cine_id: null,
        daily: {
          time: ""
        },
        weekly: {
          day: "",
          time: "",
          weekArray: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thrusday",
            "Friday",
            "Saturday"
          ]
        },
        fortnight: {
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: ""
        },
        monthly: {
          date: "",
          time: ""
        }
      }
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
  },
  mounted() {},
  methods: {
    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    onSelectCinema: function(event, params) {
      this.selectedCinema = params.cine_name;
      // this.cronTimer.cine_id = params.cine_id;
      this.cine_id = params.cine_id;
    },
    onResetForm: function() {
      this.selectedCinema = "";
      this.schedule.daily = true;
      this.schedule.weekly = false;
      this.schedule.fortnight = false;
      this.schedule.monthly = false;
      this.schedule.auto = false;
      this.cronTimer.daily.time = "";
      this.cronTimer.weekly.day = "";
      this.cronTimer.weekly.time = "";
      this.cronTimer.fortnight.startDate = "";
      this.cronTimer.fortnight.endDate = "";
      this.cronTimer.fortnight.startTime = "";
      this.cronTimer.fortnight.endTime = "";
      this.cronTimer.monthly.time = "";
      this.cronTimer.monthly.date = "";
      this.item_image_url = "Browse Backup Location";
    },
    onSelectDay: function(event, day, dayIndex) {
      this.cronTimer.weekly.day = dayIndex;
      this.selectedDay = day;
    },
    // uploadImage: function(image) {
    //   let self = this;
    //   let formData = new FormData();
    //   formData.append("image", image.target.files[0]);
    //   formData.append("imagePath", "/uploads/fnb_item/");
    //   MasterService.GlobalUploadImage(formData)
    //     .then(response => {
    //       const { data } = response;
    //       data.message ? alert(data.message) : "";
    //       if (data.status) {
    //         self.item_image_url = data.path;
    //       }
    //       self.BaseURL = data.BaseURL;
    //     })
    //     .catch(error => {
    //       alert(
    //         "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     });
    // },

    onFinalSubmit: function(flag) {
      this.submitted = true;
      Object.keys(this.cronTimer[this.selectedSchedule]).map(x => {
        // console.log("x :", x);
        // console.log("this.selectedSchedule :", this.selectedSchedule);
        if (this.cronTimer[this.selectedSchedule][x] == "") {
          this.errmsg = "Please enter manadatory fields.";
          // alert("error");
          return;
        } else {
          this.btenable = true;
          let payload = {
            filePath: this.item_image_url || "Downloads",
            cronDetails: this.cronTimer[this.selectedSchedule],
            scheduleType: this.selectedSchedule
          };
          payload.cronDetails["cine_id"] = this.cine_id;
          console.log("payload :", payload);
          CheckConnectionService.OnCreateBackup(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.Status) {
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "/master/backup-settings"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(error => {
              this.$toasted.show(error);
            });
        }
      });

      // let index = this.cronTimer.weekly.weekArray.indexOf(
      //   this.cronTimer.weekly.day
      // );
      // this.cronTimer.weekly.day = this.cronTimer.weekly.weekArray[index];
      // this.submitted = true;
      // this.$validator.validate().then(valid => {
      // console.log("valid :", valid);
      // if (valid) {

      // }
      // });
    },

    onChangeDate: function(e) {
      var dateObject = e;
      var numberOfDaysToAdd = 15;
      dateObject.setDate(dateObject.getDate() + numberOfDaysToAdd);

      var dd = dateObject.getDate();
      var mm = dateObject.getMonth() + 1;
      var y = dateObject.getFullYear();

      this.cronTimer.fortnight.endDate = dd + "/" + mm + "/" + y;
    },
    onChangeStatus: function(event, name) {
      this.selectedSchedule = name;
      Object.keys(this.schedule).map(x => {
        if (x !== name) {
          this.schedule[x] = false;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BackupSettingComponent/addBackupSettings.vue